const xMark = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="#021220" stroke-width="2.2" stroke-linecap="round"/></svg>';

export default function SetupCheckMissing() {
  return (
    <div style={{
      minHeight: '100vh',
      margin: 0,
      background: '#1a1a1a',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      padding: '24px 16px',
      boxSizing: 'border-box'
    }}>
      <div style={{
        width: 'min(520px, 100%)',
        background: '#021220',
        color: '#f3f4f6',
        border: '2px solid #f87171',
        borderRadius: 16,
        padding: '28px 32px',
        boxShadow: '0 12px 40px rgba(0,0,0,.45), 0 0 0 6px rgba(248,113,113,.16)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 16
      }}>
        <span
          style={{
            width: 32,
            height: 32,
            flex: 'none',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f87171',
            marginTop: 2
          }}
          dangerouslySetInnerHTML={{ __html: xMark }}
        />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <p style={{ margin: 0, font: '600 20px/1.4 -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif' }}>
            Script could not be loaded. Ensure you have pasted the exact code from the offer as HTML onto your page.
          </p>
          <p style={{ margin: 0, font: '400 18px/1.45 -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif', color: '#d1d5db' }}>
            If it still does not work, see if there is another way to paste code in your website editor as sometimes only one method works. If you still see this, do not worry, please reach out to support at hi@getrevtrack.com and we will help you troubleshoot this.
          </p>
        </div>
      </div>
    </div>
  );
}
